module.exports = __webpack_public_path__ + "img/index01.1107a9e9.jpg";